<section class="container pt-5 pb-4">
  <ul class="breadcrumbs">
    <li><a [routerLink]="''">Home</a></li>
    <li><a [routerLink]="'/search/results'" [queryParams]="{q: pscDetails()?.approvedName}">Search Results</a></li>
    <li>{{ pscDetails()?.approvedName || '...' }}</li>
  </ul>
</section>
<section class="psc-details-section container pb-5">
  @if (!!pscDetails()){
    <div class="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-4">
      <button
        class="btn btn-outline-dark border heading-color-1"
        (click)="utility.goBack()"
      >Back to Search Results</button>

      <div class="dropdown">
        <button class="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
          @if (downloading().pdf || downloading().json) { <loading-icon /> }
          @else { <iconify name="lucide:download" /> }
          Download PSC Data
        </button>
        <ul class="dropdown-menu">
          <li>
            <button [disabled]="downloading().pdf" class="dropdown-item d-flex align-items-center gap-2 fs-15" (click)="downloadAsPdf()">
              <iconify class="fs-20" name="material-icon-theme:pdf" /> Download As PDF
              @if (downloading().pdf) { <loading-icon /> }
            </button>
          </li>
          <li>
            <button [disabled]="downloading().json" class="dropdown-item d-flex align-items-center gap-2 fs-15" (click)="downloadAsJSON()">
              <iconify class="fs-20" name="material-icon-theme:json" /> Download As JSON
              @if (downloading().json) { <loading-icon /> }
            </button>
          </li>
        </ul>
      </div>
    </div>

    <div class="company-details card card-flexed bg-primary text-primary-foreground mb-4">
      <div class="d-flex justify-content-between gap-3 flex-wrap-reverse flex-md-nowarp">
        <div class="flex-grow-1">
          <div class="d-flex align-items-center flex-wrap gap-2">
            <h3 class="card-title d-inline text-primary-foreground">{{ pscDetails()?.approvedName }}</h3>
          </div>
          <p class="py-1 text-success d-flex align-items-center gap-3 flex-wrap fw-bold">
            <span>RC Number: {{ pscDetails()?.rcNumber }}</span><span class="text-primary-foreground opacity-50">|</span>
            @if (pscDetails()?.status === 'ACTIVE') {
              <span class="badge bg-success d-inline-flex fs-10">ACTIVE</span>
            } @else {
              <span class="badge bg-danger d-inline-flex fs-10">{{ pscDetails()?.status }}</span>
            }
          </p>
        </div>
        <div class="pt-md-2"><span class="bg-success d-inline-block py-2 px-3 rounded-3 fs-14 fw-600">
          {{ pscDetails()?.pscCount }} PSC{{ pscDetails()?.pscCount === 1 ? '' : 's' }} Registered</span></div>
      </div>
      <div class="border-bottom opacity-50"></div>
      <div class="row g-4 line-height-100p">
        <div class="col-sm-6">
          <p class="text-success text-uppercase fs-13 fw-bold pb-2">Company Type</p>
          <p class="fs-15 fw-semibold">{{ companyType }}</p>
        </div>
        <div class="col-sm-6">
          <p class="text-success text-uppercase fs-13 fw-bold pb-2">Governing Law</p>
          <p class="fs-15 fw-semibold">CAMA (Companies and Allied Matters Act)</p>
        </div>
        <div class="col-sm-6">
          <p class="text-success text-uppercase fs-13 fw-bold pb-2">Register</p>
          <p class="fs-15 fw-semibold">Corporate Affairs Commission (CAC) Nigeria</p>
        </div>
        <div class="col-sm-6">
          <p class="text-success text-uppercase fs-13 fw-bold pb-2">Country of Registration</p>
          <p class="fs-15 fw-semibold">Nigeria</p>
        </div>
      </div>
    </div>

    <div class="d-flex flex-column gap-3 pb-5">
      @for (psc of pscDetails()?.pscList || []; track psc.id) {
        <div class="card p-0 border-start border-5 border-success">
          <div class="card-body pointer" (click)="setActivePscId(psc.id!)">
            <div class="d-flex align-items-center justify-content-between gap-3">
              <div class="d-flex align-items-center gap-3">
                <div class="user-icon-wrapper d-none d-md-flex"><iconify name="lucide:user" /></div>
                <div>
                  <div class="d-flex align-items-center flex-wrap gap-2">
                    <h3 class="card-title fs-20 d-inline">{{ (`${psc?.firstname} ${psc?.otherName ?? ''} ${psc?.surname}`).replaceAll('  ', ' ') }}</h3>
                    @if (psc.status === 'ACTIVE') {
                      <span class="badge bg-success d-inline-flex fs-10">ACTIVE</span>
                    } @else {
                      <span class="badge bg-danger d-inline-flex fs-10">{{ psc?.status }}</span>
                    }
                  </div>
                  <p class="fs-13 text-uppercase pt-1">
                    @if(utility.isMobile){ PSC } @else { Person with Significant Control (PSC) }
                  </p>
                </div>
              </div>

              <div>
                <div class="d-flex align-items-center gap-2 fw-medium text-primary fs-20">
                  @if (activePscId() === psc?.id) {
                    <span class="d-none d-md-inline fs-14">Collapse</span> <iconify name="lucide:chevron-up" />
                  } @else {
                    <span class="d-none d-md-inline fs-14">Expand to View Details</span> <iconify name="lucide:chevron-down" />
                  }
                </div>
              </div>
            </div>
          </div>
          @if (activePscId() === psc?.id) {
            <div class="card-body border-top">
              <div class="row g-4 line-height-100p">
                <div class="col-sm-6 col-md-4">
                  <p class="text-uppercase fs-13 fw-bold pb-2">Nationality</p>
                  <p class="heading-color-1 fs-15 fw-semibold">{{ psc?.nationality || 'N/A' }}</p>
                </div>
                <div class="col-sm-6 col-md-4">
                  <p class="text-uppercase fs-13 fw-bold pb-2">Date of Birth</p>
                  <p class="heading-color-1 fs-15 fw-semibold">
                    @if (psc?.dateOfBirth) { {{ psc?.dateOfBirth | date: 'MMMM / yyyy' }} } @else { N/A }
                  </p>
                </div>
                <div class="col-sm-6 col-md-4">
                  <p class="text-uppercase fs-13 fw-bold pb-2">Occupation</p>
                  <p class="heading-color-1 fs-15 fw-semibold">{{ psc?.occupation || 'N/A' }}</p>
                </div>
                <div class="col-sm-6 col-md-4">
                  <p class="text-uppercase fs-13 fw-bold pb-2">Date of Notification</p>
                  <p class="heading-color-1 fs-15 fw-semibold">
                    @if (psc?.dateOfAppointment) { {{ psc?.dateOfAppointment | date: 'dd MMMM, yyyy' }} } @else { N/A }
                  </p>
                </div>
                <div class="col-sm-6 col-md-8">
                  <p class="text-uppercase fs-13 fw-bold pb-2">Service Address</p>
                  <p class="heading-color-1 fs-15 fw-semibold">{{ psc?.address || 'N/A' }}</p>
                </div>
              </div>
              <div class="border-top mt-4 pt-4">
                <h4 class="text-primary fs-18 heading-font fw-bold mb-3">Statutory Ownership & Control Matrix</h4>
                <ul class="psc-details-wrapper">
                  <li class="details-item">
                    <div class="check-icon-wrapper d-none d-md-flex"><iconify name="lucide:check" /></div>
                    <div class="flex-grow-1 d-flex flex-column align-self-center gap-2">
                      <p class="fw-medium line-height-150p">Does the PSC directly or indirectly hold at least [5%] of the shares or interest in a company or limited liability partnership?</p>
                      <p [class]="(psc?.pscHoldsSharesOrInterest || psc?.pscHoldsSharesOrInterestIndirect) ? 'text-success' : 'text-danger'"> {{ (psc?.pscHoldsSharesOrInterest || psc?.pscHoldsSharesOrInterestIndirect) ? 'YES' : 'NO' }} –
                        Directly: [ {{ psc?.pscHoldsSharesOrInterestPercentageDirectly || 0 }}% ] and Indirectly: [ {{ psc?.pscHoldsSharesOrInterestPercentageIndirectly || 0 }}% ]
                      </p>
                      @if ((psc?.pscHoldsSharesOrInterest || psc?.pscHoldsSharesOrInterestIndirect)) {
                        <p class="text-success">{{ (psc?.pscHoldsSharesOrInterestPercentageDirectly || 0) + (psc?.pscHoldsSharesOrInterestPercentageIndirectly || 0) }}% Ownership</p>
                      }
                    </div>
                    <div>
                      @if ((psc?.pscHoldsSharesOrInterest || psc?.pscHoldsSharesOrInterestIndirect)) {
                        <span class="badge bg-success">YES</span>
                      } @else {
                        <span class="badge bg-danger">NO</span>
                      }
                    </div>
                  </li>
                  <li class="details-item">
                    <div class="check-icon-wrapper d-none d-md-flex"><iconify name="lucide:check" /></div>
                    <div class="flex-grow-1 d-flex flex-column align-self-center gap-2">
                      <p class="fw-medium line-height-150p">Does the PSC directly or indirectly hold at least [5%] of the voting rights in a company or limited liability partnership?</p>
                      <p [class]="(psc?.pscVotingRights || psc?.pscHoldsVotingRightsPercentageIndirectly) ? 'text-success' : 'text-danger'"> {{ (psc?.pscVotingRights || psc?.pscHoldsVotingRightsPercentageIndirectly) ? 'YES' : 'NO' }} –
                        Directly: [ {{ psc?.pscVotingRightsPercentageDirectly || 0 }}% ] and Indirectly: [ {{ psc?.pscVotingRightsPercentageIndirectly || 0 }}% ]
                      </p>
                      @if ((psc?.pscVotingRights || psc?.pscHoldsVotingRightsPercentageIndirectly)) {
                        <p class="text-success">{{ (psc?.pscVotingRightsPercentageDirectly || 0) + (psc?.pscVotingRightsPercentageIndirectly || 0) }}% Voting Rights</p>
                      }
                    </div>
                    <div>
                      @if ((psc?.pscVotingRights || psc?.pscHoldsVotingRightsPercentageIndirectly)) {
                        <span class="badge bg-success">YES</span>
                      } @else {
                        <span class="badge bg-danger">NO</span>
                      }
                    </div>
                  </li>
                  <li class="details-item">
                    <div class="check-icon-wrapper d-none d-md-flex"><iconify name="lucide:check" /></div>
                    <div class="flex-grow-1 d-flex flex-column align-self-center gap-2">
                      <p class="fw-medium line-height-150p">Does the PSC directly or indirectly hold the right to appoint or remove a majority of the directors or partners in a company or limited liability partnership?</p>
                    </div>
                    <div>
                      @if (psc?.pscRightToAppoint) {
                        <span class="badge bg-success">YES</span>
                      } @else {
                        <span class="badge bg-danger">NO</span>
                      }
                    </div>
                  </li>
                  <li class="details-item">
                    <div class="check-icon-wrapper d-none d-md-flex"><iconify name="lucide:check" /></div>
                    <div class="flex-grow-1 d-flex flex-column align-self-center gap-2">
                      <p class="fw-medium line-height-150p">Does the PSC otherwise have the right to exercise or is actually exercising significant influence or control over a company or limited liability partnership?</p>
                    </div>
                    <div>
                      <div>
                        @if (psc?.pscSignificantInfluence || psc?.pscExerciseSignificantInfluence) {
                          <span class="badge bg-success">YES</span>
                        } @else {
                          <span class="badge bg-danger">NO</span>
                        }
                      </div>
                    </div>
                  </li>
                  <li class="details-item">
                    <div class="check-icon-wrapper d-none d-md-flex"><iconify name="lucide:check" /></div>
                    <div class="flex-grow-1 d-flex flex-column align-self-center gap-2">
                      <p class="fw-medium line-height-150p">Does the PSC have the right to exercise, or actually exercise significant influence or control over the activities of a trust or firm, whether or not it is a legal entity, but would itself satisfy any of the first four conditions if it were an individual?</p>
                    </div>
                    <div>
                      @if (psc?.pscSignificantInfluence || psc?.pscExerciseSignificantInfluence) {
                        <span class="badge bg-success">YES</span>
                      } @else {
                        <span class="badge bg-danger">NO</span>
                      }
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          }
        </div>
      }

      <div class="d-flex align-items-center justify-content-between flex-wrap gap-3 pt-3">
        <button
          class="btn btn-outline-dark border heading-color-1"
          (click)="utility.goBack()"
        >Back to Search Results</button>
        <div class="d-flex align-items-center flex-wrap gap-3">
          <button [disabled]="downloading().pdf" class="btn btn-primary" (click)="downloadAsPdf()">
            @if (downloading().pdf) { <loading-icon /> }
            @else { <iconify name="lucide:file-text" /> }
            Download PSC Data (PDF)
          </button>
          <button [disabled]="downloading().json" class="btn btn-success" (click)="downloadAsJSON()">
            @if (downloading().json) { <loading-icon /> }
            @else { <iconify name="lucide:file-braces-corner" /> }
            Download PSC Data (JSON)
          </button>
        </div>
      </div>
    </div>
  } @else {
    <div class="card card-flexed bg-primary text-primary-foreground mb-4">
      <div class="d-flex justify-content-between gap-3 flex-wrap-reverse flex-md-nowarp">
        <div class="flex-grow-1">
          <div><ngx-skeleton-loader appearance="line" animation="progress-dark" [theme]="{maxWidth: '600px', background: 'var(--primary-color)'}"  /></div>
          <div class="py-1 text-success d-flex align-items-center gap-3 flex-wrap fw-bold line-height-0">
            <div style="width: 100px"><ngx-skeleton-loader appearance="line" animation="progress-dark" [theme]="{background: 'var(--primary-color)'}" /></div>
            <span class="text-primary-foreground opacity-50">|</span>
            <div style="width: 100px"><ngx-skeleton-loader appearance="line" animation="progress-dark" [theme]="{background: 'var(--primary-color)'}" /></div>
          </div>
        </div>
        <div class="pt-md-2">
          <div style="width: 100px; max-width: 100%;"><ngx-skeleton-loader appearance="line" animation="progress-dark" [theme]="{background: 'var(--primary-color)'}" /></div>
        </div>
      </div>
      <div class="border-bottom opacity-50"></div>
      <div class="row g-4 line-height-100p">
        <div class="col-sm-6">
          <div style="width: 200px; max-width: 100%;"><ngx-skeleton-loader appearance="line" animation="progress-dark" [theme]="{background: 'var(--primary-color)'}" /></div>
          <div style="width: 400px; max-width: 100%;"><ngx-skeleton-loader appearance="line" animation="progress-dark" [theme]="{background: 'var(--primary-color)'}" /></div>
        </div>
        <div class="col-sm-6">
          <div style="width: 200px; max-width: 100%;"><ngx-skeleton-loader appearance="line" animation="progress-dark" [theme]="{background: 'var(--primary-color)'}" /></div>
          <div style="width: 400px; max-width: 100%;"><ngx-skeleton-loader appearance="line" animation="progress-dark" [theme]="{background: 'var(--primary-color)'}" /></div>
        </div>
        <div class="col-sm-6">
          <div style="width: 200px; max-width: 100%;"><ngx-skeleton-loader appearance="line" animation="progress-dark" [theme]="{background: 'var(--primary-color)'}" /></div>
          <div style="width: 400px; max-width: 100%;"><ngx-skeleton-loader appearance="line" animation="progress-dark" [theme]="{background: 'var(--primary-color)'}" /></div>
        </div>
      </div>
    </div>

    <div class="card card-flexed mb-3">
      <div>
        <div><ngx-skeleton-loader appearance="line" [theme]="{maxWidth: '600px'}"  /></div>
        <div><ngx-skeleton-loader appearance="line" [theme]="{maxWidth: '200px'}"  /></div>
      </div>
      <div class="border-bottom"></div>
      <div class="row g-3 line-height-100p">
        <div class="col-sm-6">
          <div><ngx-skeleton-loader appearance="line" [theme]="{maxWidth: '70%'}" /></div>
          <div><ngx-skeleton-loader appearance="line" [theme]="{maxWidth: '50%'}" /></div>
        </div>
        <div class="col-sm-6">
          <div><ngx-skeleton-loader appearance="line" [theme]="{maxWidth: '70%'}" /></div>
          <div><ngx-skeleton-loader appearance="line" [theme]="{maxWidth: '50%'}" /></div>
        </div>
      </div>
    </div>
    <div class="card card-flexed mb-3">
      <div>
        <div><ngx-skeleton-loader appearance="line" [theme]="{maxWidth: '600px'}"  /></div>
        <div><ngx-skeleton-loader appearance="line" [theme]="{maxWidth: '200px'}"  /></div>
      </div>
      <div class="border-bottom"></div>
      <div class="row g-3 line-height-100p">
        <div class="col-sm-6">
          <div><ngx-skeleton-loader appearance="line" [theme]="{maxWidth: '70%'}" /></div>
          <div><ngx-skeleton-loader appearance="line" [theme]="{maxWidth: '50%'}" /></div>
        </div>
        <div class="col-sm-6">
          <div><ngx-skeleton-loader appearance="line" [theme]="{maxWidth: '70%'}" /></div>
          <div><ngx-skeleton-loader appearance="line" [theme]="{maxWidth: '50%'}" /></div>
        </div>
      </div>
    </div>
  }
</section>
